/**
 * @file CanvasVersionBar.tsx
 * @description Полоса над канвой при просмотре версии страницы (phase19.16
 * Р3а; uiux-r3 §3.1): только кнопки [Вернуть эту версию] [Закрыть] —
 * подпись «Версия N от … — так было на сайте» рисует витрина во фрейме.
 * На 360 кнопки переносятся и делят ширину (QA Р3а D2: без
 * горизонтальной прокрутки), касание 48.
 */

import { Button } from "../../ui/button";

interface Props {
  label: string;
  action?: { label: string; run: () => void };
  onClose: () => void;
}

export function CanvasVersionBar({ label, action, onClose }: Props) {
  return (
    <div role="status" className="flex min-w-0 shrink-0 flex-wrap gap-2">
      <span className="sr-only">{label}. Править в этом режиме нельзя.</span>
      {action ? (
        <Button className="min-w-0 flex-1 sm:flex-none" onClick={action.run}>
          {/* На 360 при половине ширины полная подпись не влезает — короткая (QA Р3а, повтор). */}
          <span className="truncate max-sm:hidden">{action.label}</span>
          <span className="truncate sm:hidden">Вернуть версию</span>
        </Button>
      ) : null}
      <Button variant="outline" className="min-w-0 flex-1 sm:flex-none" onClick={onClose}>
        Закрыть
      </Button>
    </div>
  );
}
